import { Expose } from "class-transformer";
import { IsNumber, IsOptional, IsString } from "class-validator";

export class Printer {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsOptional()
  @IsString()
  description!: string | null;
  @Expose()
  @IsString()
  name!: string;
}
